(function () {
  'use strict';

  if (document.documentElement.dataset.institutionalPagesScriptReady === 'true') return;
  document.documentElement.dataset.institutionalPagesScriptReady = 'true';

  function initializePage(page) {
    if (!page || page.dataset.institutionalReady === 'true') return;
    page.dataset.institutionalReady = 'true';
    var cleanupCallbacks = [];

    page.querySelectorAll('[data-testimonial-rail]').forEach(function (rail) {
      var track = rail.querySelector('[data-testimonial-track]');
      var previous = rail.querySelector('[data-scroll-direction="previous"]');
      var next = rail.querySelector('[data-scroll-direction="next"]');
      if (!track || !previous || !next) return;

      function updateControls() {
        var maximum = Math.max(0, track.scrollWidth - track.clientWidth);
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= maximum - 2;
      }

      function move(direction) {
        var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        track.scrollBy({
          left: direction * Math.max(280, track.clientWidth * 0.82),
          behavior: reducedMotion ? 'auto' : 'smooth'
        });
      }

      function showPrevious() {
        move(-1);
      }

      function showNext() {
        move(1);
      }

      previous.addEventListener('click', showPrevious);
      next.addEventListener('click', showNext);
      track.addEventListener('scroll', updateControls, { passive: true });

      var resizeObserver = null;
      if ('ResizeObserver' in window) {
        resizeObserver = new ResizeObserver(updateControls);
        resizeObserver.observe(track);
      } else {
        window.addEventListener('resize', updateControls);
      }

      cleanupCallbacks.push(function () {
        previous.removeEventListener('click', showPrevious);
        next.removeEventListener('click', showNext);
        track.removeEventListener('scroll', updateControls);
        if (resizeObserver) resizeObserver.disconnect();
        else window.removeEventListener('resize', updateControls);
      });
      updateControls();
    });

    page.institutionalCleanup = function () {
      cleanupCallbacks.forEach(function (cleanup) {
        cleanup();
      });
      page.institutionalCleanup = null;
    };
  }

  function initializeAll(root) {
    if (root && root.matches && root.matches('[data-institutional-page]')) initializePage(root);
    (root || document).querySelectorAll('[data-institutional-page]').forEach(initializePage);
  }

  function cleanupAll(root) {
    var pages = [];
    if (root && root.matches && root.matches('[data-institutional-page]')) pages.push(root);
    (root || document).querySelectorAll('[data-institutional-page]').forEach(function (page) {
      pages.push(page);
    });
    pages.forEach(function (page) {
      if (typeof page.institutionalCleanup === 'function') page.institutionalCleanup();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeAll(document);
    });
  } else {
    initializeAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    cleanupAll(event.target);
  });
})();
